(function () {
    'use strict';

    angular.module('l4b')
        .component('requiredDocumentationSubmit', {
            templateUrl: 'html/shared/requiredDocumentationSubmit/requiredDocumentationSubmit.html',
            bindings: {
				nextStep: '&'
            },
            controller: RequiredDocumentationSubmitController,
            controllerAs: 'vm'
        });

    RequiredDocumentationSubmitController.$inject = ['GuidedProofService', 'Constants', 'StorageService', 'RestService', '$rootScope', '$timeout', 'FlowService'];

    function RequiredDocumentationSubmitController(GuidedProofService, Constants, StorageService, RestService, $rootScope, $timeout, FlowService) {
        var vm = this;

        angular.extend(vm, {
			$onInit: init,
            actualNumber: 1,
            totalNumber: 0,
            showError: false,
            showSpinner: false,
            processingMessageIndex: 0,
            showInvalidFileError: false,
            retries: 2,
            proofsFailed: [],
            allowedFileFormats: ".png, .jpeg, .jpg, .pdf",
            continueAnyways: continueAnyways,
            resubmit: resubmit
        });

        function IsProofReviewed(proofCode) {

            return new Promise(function (resolve, reject) {

                RestService.pollApplication(
                    function (result) {

                        try {
                            // Find the specific requirement by code
                            var requirements = result.data != null ? result.data.Requirements || [] : [];
                            StorageService.set(Constants.SK.Application, result.data);
                            var req = requirements.find(r => r.code === proofCode);
                            if (!req) {
                                resolve({
                                    IsApproved: false
                                });
                                return;
                            }
                            var isApproved = !!req.isApproved;

                            resolve({
                                IsApproved: isApproved
                            });

                        } catch (err) {
                            reject(err);
                        }
                    },
                    function (error) {
                        reject(error);
                    }
                );
            });
        }
		function init() {
			
            if (!GuidedProofService.ValidateProofData()) {
				return;
			}
         
            vm.totalNumber = GuidedProofService.GetProofsToSubmitCount();

            var config = StorageService.get(Constants.SK.Configuration);

            vm.allowedFileFormats = config && config.allowedFileFormats 
                                    ?  config.allowedFileFormats
                                    :  vm.allowedFileFormats;

            GuidedProofService.SubmitAllProofs()
                .then(onSuccess, onError, onNotify);				
		}		

        function onSuccess(response) {
            var isReviewableByAutomaticAgent = response.data.IsReviewableByAutomaticAgent;
            var currentProof = GuidedProofService.GetCurrentProofData();

            if (vm.proofsFailed.length == 0) {

                var hasNextProof = GuidedProofService.GetMissingProofs().length > 0;
                if (!hasNextProof && isReviewableByAutomaticAgent) {

                    vm.showSpinner = true;
                    $rootScope.showGeneralSpinner = true;

                    vm.processingMessageIndex = 0;
                    var messageRotationInterval = 5000; // Change message every 5 seconds
                    var messageRotationTimer;

                    function rotateMessages() {
                        vm.processingMessageIndex = (vm.processingMessageIndex === 0 ? 1 : 0);
                        messageRotationTimer = $timeout(rotateMessages, messageRotationInterval);
                    }

                    rotateMessages();

                    var config = StorageService.get(Constants.SK.Configuration);
                    var intervalSeconds = config.approvalPollingIntervalSeconds != null ?
                        config.approvalPollingIntervalSeconds : 2; // polling frequency
                    var timeoutSeconds = config.approvalPollingTimeoutSeconds != null ?
                        config.approvalPollingTimeoutSeconds : 30; // total time allowed
                    var startTime = Date.now();

                    function stopRotation() {
                        if (messageRotationTimer) {
                            $timeout.cancel(messageRotationTimer);
                        }
                    }

                    function poll() {
                        IsProofReviewed(currentProof.code).then(function (result) {
                            if (result.IsApproved) {
                                stopRotation();
                                $rootScope.showGeneralSpinner = false;
                                vm.nextStep({ options: { autoSuccess: true } });
                                return;
                            }

                            var elapsed = (Date.now() - startTime) / 1000;
                            if (elapsed >= timeoutSeconds) {
                                stopRotation();
                                $rootScope.showGeneralSpinner = false;

                                // Continue normal flow → human review
                                vm.nextStep({ options: { nextProof: hasNextProof } });
                                return;
                            }

                            // Keep polling
                            $timeout(poll, intervalSeconds * 1000);

                        }).catch(function (err) {
                            console.error("Error while polling review status", err);
                            stopRotation();
                            $rootScope.showGeneralSpinner = false;
                        });
                    }

                    poll();

                } else {
                    // keeps regular flow
                    vm.nextStep({ options: { nextProof: hasNextProof } });
                }

            } else {
                if (response.data.ExceptionMessage == Constants.Error.INVALID_FORMAT_ERROR) {
                    vm.showInvalidFileError = true;
                    return;
                }

                vm.showError = true;
            }
        }



        function continueAnyways() {
            vm.nextStep({ options: { error: true } });
        }

        function resubmit() {
            vm.retries--;
            vm.showError = false;
            vm.totalNumber = GuidedProofService.GetProofsToSubmitCount();

            GuidedProofService.SubmitAllProofs()
                .then(onSuccess, onError, onNotify);
        }

        function onError() {
            vm.showError = true;
        }

        function onNotify(update) {
            if (!update) {
                return;
            }

            if (update.proofToSubmit) {
                vm.proofSubmitting = update.proofToSubmit;
            }

            if (update.actualCount) {
                vm.actualNumber = update.actualCount;
            }

            if (update.maxFiles) {
                vm.totalNumber = update.maxFiles;
            }

            if (update.proofFailed) {
                vm.proofsFailed.push(update.proofFailed);
            }
        }
    }

})();